import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { ListForStudentComponent } from './list-for-student/list-for-student.component';
import { ProjectsComponent } from './projects/projects.component';
import { FaqsComponent } from './faqs/faqs.component';
import { ResourcesComponent } from './resources/resources.component';

const routes: Routes = [
  {
    path:'lists',component: ListComponent
  },
  {
    path:'my-assignments',component: ListForStudentComponent
  },
  {
    path:'student-assignments/:id',component: ListForStudentComponent
  },
  {
    path:'grades',component: ListForStudentComponent
  },
  {
    path:'student-grades/:id',component: ListForStudentComponent
  },
  {
    path:'projects',component: ProjectsComponent
  },
  {
    path:'student-projects/:id',component: ProjectsComponent
  },
  {
    path:'faqs/:id',component: FaqsComponent
  },
  {
    path:'all-resources',component: ResourcesComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssignmentRoutingModule { }
